import { StyleProp, ViewStyle } from "react-native";
import { AHIcon } from "./AHIcon";
import { Circle } from "./AHTheme/Circle";
import { ColorType } from "./AHTheme/AHTheme";

export function AHRadioButton(props: { selected?: boolean }) {
  return (
    <SelectDot selected={!!props.selected}>
      {props.selected ? (
        <AHIcon type="check" color="text-inverted" size="small" />
      ) : null}
    </SelectDot>
  );
}

type SelectDotProps = {
  selected: boolean;
  children?: React.ReactNode;
  style?: StyleProp<ViewStyle>;
  selectedDotColor?: ColorType;
  backgroundColor?: ColorType;
  disabled?: boolean;
};

export const SelectDot = ({
  backgroundColor = "surface-backgroundControl",
  children,
  ...props
}: SelectDotProps) => {
  return (
    <Circle
      size="smallMedium"
      color={props.selected ? "status-active" : backgroundColor}
      borderColor={props.selected ? "status-active" : "border-strong"}
      style={{
        borderWidth: 1,
        opacity: props.disabled ? 0.5 : 1,
      }}
    >
      {children}
    </Circle>
  );
};
